import { HomeworkCardRead } from './HomeworkCardRead';
export default HomeworkCardRead;
